import { AWS_REGIONS, AUTH_TYPES, SCHEDULE_OPTIONS } from '../../constants';
import type { FieldConfig, SelectFieldConfig, TextFieldConfig } from './types';

// Schedule field - used in ALL forms
// NOTE: Use array to specify top-level field (not nested under 'configuration')
export const scheduleField: SelectFieldConfig = {
    name: ['schedule'],
    label: 'Schedule',
    type: 'select',
    placeholder: 'Select schedule',
    options: SCHEDULE_OPTIONS,
    initialValue: null,
};

// AWS Region field - used in S3, HealthLake, AwsHealthImaging
export const awsRegionField: SelectFieldConfig = {
    name: 'region',
    label: 'AWS Region',
    type: 'select',
    required: true,
    placeholder: 'Select region',
    options: AWS_REGIONS,
    showSearch: true,
    initialValue: 'us-east-1',
};

// AWS Credentials fields
export const awsCredentialsFields: FieldConfig[] = [
    {
        name: 'accessKeyId',
        label: 'Access Key ID',
        type: 'text',
        required: true,
        placeholder: 'AKIAIOSFODNN7EXAMPLE',
        isCredential: true,
    },
    {
        name: 'secretAccessKey',
        label: 'Secret Access Key',
        type: 'password',
        required: true,
        placeholder: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY',
        isCredential: true,
    },
    awsRegionField,
];

// Authentication type field
export const authTypeField = (onChange?: (value: unknown) => void): SelectFieldConfig => ({
    name: 'authType',
    label: 'Authentication Type',
    type: 'select',
    required: true,
    placeholder: 'Select authentication type',
    options: AUTH_TYPES,
    initialValue: 'none',
    onChange,
});

// Username field
export const usernameField: FieldConfig = {
    name: 'username',
    label: 'Username',
    type: 'text',
    required: true,
    placeholder: 'Enter username',
    isCredential: true,
};

// Password field
export const passwordField: FieldConfig = {
    name: 'password',
    label: 'Password',
    type: 'password',
    required: true,
    placeholder: 'Enter password',
    isCredential: true,
};

// Basic auth fields
export const basicAuthFields: FieldConfig[] = [usernameField, passwordField];

// Bearer token field
export const bearerTokenField: FieldConfig = {
    name: 'bearerToken',
    label: 'Bearer Token',
    type: 'password',
    required: true,
    placeholder: 'Enter bearer token',
    isCredential: true,
};

// Private key field
export const privateKeyField: FieldConfig = {
    name: 'privateKey',
    label: 'Private Key',
    type: 'textarea',
    required: true,
    placeholder: '-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----',
    rows: 4,
    isCredential: true,
};

// Host field
export const hostField: FieldConfig = {
    name: 'host',
    label: 'Host',
    type: 'text',
    required: true,
    placeholder: 'example.com',
};

// Port field
export const portField: FieldConfig = {
    name: 'port',
    label: 'Port',
    type: 'number',
    required: true,
    initialValue: 22,
    min: 1,
    max: 65535,
    placeholder: '22',
};

// Common URL field factory
export const createUrlField = (name: string, label: string, placeholder: string, extra?: string): FieldConfig => ({
    name,
    label,
    type: 'url',
    required: true,
    placeholder,
    extra,
});

// Common text field factory
export const createTextField = (
    name: string,
    label: string,
    placeholder: string,
    options?: Omit<Partial<TextFieldConfig>, 'type' | 'name' | 'label' | 'placeholder'>
): TextFieldConfig => ({
    name,
    label,
    type: 'text',
    placeholder,
    ...options,
});
